export default {
  getConversions: (t) => {
    return {
      "GSheets-Initial": {
        title: "GSheets-Initial",
        name: "",
        value: "0.00",
        lastSend: "",
        id: 0,
      },
      "GSheets-Conversion1": {
        title: "GSheets-Conversion1",
        name: "",
        value: "0.00",
        lastSend: "",
        id: 1,
      },
      "GSheets-Conversion2": {
        title: "GSheets-Conversion2",
        name: "",
        value: "0.00",
        lastSend: "",
        id: 2,
      },
      "GSheets-Conversion3": {
        title: "GSheets-Conversion3",
        name: "",
        value: "0.00",
        lastSend: "",
        id: 3,
      },
      "GSheets-Conversion4": {
        title: "GSheets-Conversion4",
        name: "",
        value: "0.00",
        lastSend: "",
        id: 4,
      },
      "GSheets-Conversion5": {
        title: "GSheets-Conversion5",
        name: "",
        value: "0.00",
        lastSend: "",
        id: 5,
      },
      "GSheets-Conversion6": {
        title: "GSheets-Conversion6",
        name: "",
        value: "0.00",
        lastSend: "",
        id: 6,
      },
      "GSheets-Conversion7": {
        title: "GSheets-Conversion7",
        name: "",
        value: "0.00",
        lastSend: "",
        id: 7,
      },
      "GSheets-Conversion8": {
        title: "GSheets-Conversion8",
        name: "",
        value: "0.00",
        lastSend: "",
        id: 8,
      },
      "GSheets-Conversion9": {
        title: "GSheets-Conversion9",
        name: "",
        value: "0.00",
        lastSend: "",
        id: 9,
      },
      "GSheets-Conversion10": {
        title: "GSheets-Conversion10",
        name: "",
        value: "0.00",
        lastSend: "",
        id: 10,
      },
    };
  },
};
